import { StyledCloseIcon, StyledTagItem, StyledTagItemContent } from './styled';

export type TagItemProps = {
	/**
	 * Inner text content of tag
	 */
	label: string;

	/**
	 * Type of tag. Comes in two variants:
	 * * Button with an cross icon
	 * * Plain button
	 */
	plain?: boolean;

	/**
	 * Event handler callback. Is evoked when the tag is clicked
	 */
	onClick: (label: string) => void;
};

export const TagItem = ({ label, onClick: onClick, plain = false }: TagItemProps) => {
	return (
		<StyledTagItem>
			<StyledTagItemContent
				plain={plain}
				onClick={() => onClick(label)}
			>
				{!plain && <StyledCloseIcon />}
				{label}
			</StyledTagItemContent>
		</StyledTagItem>
	);
};
